export function ProposalOrderPreviewContainer({
  children,
}: {
  children: React.ReactNode
}) {
  return <div className="flex flex-col h-full overflow-hidden">{children}</div>
}

export function SummaryBannerContainer({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <div className="shrink-0 px-4 pb-3 border-b border-primary-border">
      {children}
    </div>
  )
}

export function OrderDetailsContainer({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <div className="shrink-0 px-4 py-3 border-primary-border">{children}</div>
  )
}

export function ProposalOrderPreviewTabContentContainer({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <div className="flex-1 overflow-y-auto scrollbar-hide min-h-0">
      {children}
    </div>
  )
}

export function ProposalAllocationsContainer({
  children,
}: {
  children: React.ReactNode
}) {
  return <div className="shrink-0 overflow-y-auto">{children}</div>
}

export function ProposalOrderDetailsFooter({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <div className="fixed bottom-0 w-full flex px-4 py-3 border-primary-border border-t justify-end">
      {children}
    </div>
  )
}

export function OrderStatusBarContainer({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <div className="shrink-0 w-full px-4 py-3 flex space-x-2 items-center">
      {children}
    </div>
  )
}
